import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isFunction } from 'lodash/lang';

import TextArea from '../../../../../../../../common/data-entry/TextArea/TextArea';
import ModalBoxes from '../../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../../common/general/ButtonGroup';
import { NSPP_PATIENT } from '../../../../../../../../services/i18n/namespaces';

import './PatientInstructionEditModal.scss';

const PatientInstructionEditModal = ({ modalBox, initialInstruction, onSave }) => {
  const { t } = useTranslation();
  const [instruction, setInstruction] = useState(initialInstruction || '');

  const onClick = function() {
    isFunction(onSave) && onSave(instruction);
  };

  return (
    <>
      <ModalBoxes.Header>
        {t(`${NSPP_PATIENT}:info.instructions.instruction`, { value: initialInstruction ? t('edit') : t('new') })}
      </ModalBoxes.Header>
      <ModalBoxes.Body>
        <TextArea
          style={{ resize: 'none' }}
          value={instruction}
          rows={1}
          clearable
          onChange={({ target }) => setInstruction(target.value)}
          label={t(`${NSPP_PATIENT}:info.instructions.enterInstruction`)}
          name={t(`${NSPP_PATIENT}:info.instructions.enterInstruction`)}
        />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            {t('cancel')}
          </Button>
          <Button disabled={instruction === ''} onClick={onClick}>
            {t('save')}
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
};

PatientInstructionEditModal.className = 'patient-instruction-change-modal';
PatientInstructionEditModal.size = 'w650';

export default PatientInstructionEditModal;
